import styled from 'styled-components'

export const Toggler = styled.section`
  cursor: pointer;

  &.switch-button.left{
    button.left{
      color:#ddd;
    }
    .switch{
      left: 0;
    }
  }

  &.switch-button.right {
    button.right{
      color:#ddd;
    }
    .switch{
      left: 50%;
    }
  }

  &.switch-button .switch{
    transition: all .5s;
    float:left;
    text-align:center;
    z-index:0;
    background-color:#121a3d;
    width:50%;
    height: 100%;
    font-weight:800;
    position:absolute;
  }

  &.switch-button button{
    float:left;
    background-color:transparent !important;
    color:#444;
    border:0;
    font-size:.875rem;
    padding:2%;
    width:50%;
    height: 30px;
    font-weight:500;
    z-index:1;
    text-align:center;
    position:relative;
    transition-delay: .2s;
    border: 1px solid #121a3d;
  }


  &.switch-button{
    background: white;
    border: solid 0.8px #eeeeee;
    position:relative;
    font-size:12px;
    font-weight: 600;
    overflow:hidden;
    width: 280px;
    float:left;
    input{
      display:none;
    }
  }
`;
